import { render } from "./BarChart-horizontal-single.vue?vue&type=template&id=acacb28e"
import script from "./BarChart-horizontal-single.vue?vue&type=script&lang=js"
export * from "./BarChart-horizontal-single.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__